/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export enum Bundesland {
    Burgenland = 'Burgenland',
    Krnten = 'Kärnten',
    Niedersterreich = 'Niederösterreich',
    Obersterreich = 'Oberösterreich',
    Salzburg = 'Salzburg',
    Steiermark = 'Steiermark',
    Tirol = 'Tirol',
    Vorarlberg = 'Vorarlberg',
    Wien = 'Wien'
}


/**
 * 
 * @export
 * @interface CodeListItem
 */
export interface CodeListItem {
    /**
     * 
     * @type {number}
     * @memberof CodeListItem
     */
    'key': number | null;
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface Dataset
 */
export interface Dataset {
    /**
     * 
     * @type {EndpointType}
     * @memberof Dataset
     */
    'type': EndpointType;
    /**
     * 
     * @type {EndpointMode}
     * @memberof Dataset
     */
    'mode': EndpointMode;
    /**
     * 
     * @type {Array<OutputFormat>}
     * @memberof Dataset
     */
    'response_formats': Array<OutputFormat>;
    /**
     * 
     * @type {string}
     * @memberof Dataset
     */
    'url': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum EndpointMode {
    Historical = 'historical',
    Current = 'current',
    Forecast = 'forecast'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum EndpointType {
    Grid = 'grid',
    Timeseries = 'timeseries',
    Station = 'station'
}


/**
 * 
 * @export
 * @interface Frequency
 */
export interface Frequency {
}
/**
 * 
 * @export
 * @interface FrequencyStep
 */
export interface FrequencyStep {
    /**
     * 
     * @type {number}
     * @memberof FrequencyStep
     */
    'from_index': number;
    /**
     * 
     * @type {number}
     * @memberof FrequencyStep
     */
    'to_index': number;
    /**
     * 
     * @type {string}
     * @memberof FrequencyStep
     */
    'frequency': string;
    /**
     * 
     * @type {string}
     * @memberof FrequencyStep
     */
    'step_offset': string;
}
/**
 * 
 * @export
 * @interface GeoJSONFeature
 */
export interface GeoJSONFeature {
    /**
     * 
     * @type {string}
     * @memberof GeoJSONFeature
     */
    'type'?: GeoJSONFeatureTypeEnum;
    /**
     * 
     * @type {GeoJSONPoint}
     * @memberof GeoJSONFeature
     */
    'geometry': GeoJSONPoint;
    /**
     * 
     * @type {GeoJSONFeatureProperties}
     * @memberof GeoJSONFeature
     */
    'properties': GeoJSONFeatureProperties;
}

/**
    * @export
    * @enum {string}
    */
export enum GeoJSONFeatureTypeEnum {
    Feature = 'Feature'
}

/**
 * 
 * @export
 * @interface GeoJSONFeatureParameter
 */
export interface GeoJSONFeatureParameter {
    /**
     * 
     * @type {string}
     * @memberof GeoJSONFeatureParameter
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GeoJSONFeatureParameter
     */
    'unit': string;
    /**
     * 
     * @type {Array<number | null>}
     * @memberof GeoJSONFeatureParameter
     */
    'data': Array<number | null>;
}
/**
 * 
 * @export
 * @interface GeoJSONFeatureProperties
 */
export interface GeoJSONFeatureProperties {
    /**
     * 
     * @type {{ [key: string]: GeoJSONFeatureParameter | undefined; }}
     * @memberof GeoJSONFeatureProperties
     */
    'parameters': { [key: string]: GeoJSONFeatureParameter | undefined; };
}
/**
 * 
 * @export
 * @interface GeoJSONPoint
 */
export interface GeoJSONPoint {
    /**
     * 
     * @type {string}
     * @memberof GeoJSONPoint
     */
    'type'?: GeoJSONPointTypeEnum;
    /**
     * Point coordinates are in x, y order (easting, northing for projected coordinates, longitude, and latitude for geographic coordinates)
     * @type {Array<number>}
     * @memberof GeoJSONPoint
     */
    'coordinates': Array<number>;
}

/**
    * @export
    * @enum {string}
    */
export enum GeoJSONPointTypeEnum {
    Point = 'Point'
}

/**
 * 
 * @export
 * @interface GridForecastGeoJSONSerializer
 */
export interface GridForecastGeoJSONSerializer {
    /**
     * 
     * @type {string}
     * @memberof GridForecastGeoJSONSerializer
     */
    'reference_time': string;
    /**
     * 
     * @type {string}
     * @memberof GridForecastGeoJSONSerializer
     */
    'media_type'?: GridForecastGeoJSONSerializerMediaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GridForecastGeoJSONSerializer
     */
    'type'?: GridForecastGeoJSONSerializerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GridForecastGeoJSONSerializer
     */
    'version': string;
    /**
     * Format: *YYYY-MM-DDThh:mm:ss±hh:mm*
     * @type {Array<string>}
     * @memberof GridForecastGeoJSONSerializer
     */
    'timestamps': Array<string>;
    /**
     * 
     * @type {Array<GeoJSONFeature>}
     * @memberof GridForecastGeoJSONSerializer
     */
    'features': Array<GeoJSONFeature>;
    /**
     * 
     * @type {string}
     * @memberof GridForecastGeoJSONSerializer
     */
    'filename'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridForecastGeoJSONSerializer
     */
    'bbox': Array<number>;
}

/**
    * @export
    * @enum {string}
    */
export enum GridForecastGeoJSONSerializerMediaTypeEnum {
    ApplicationJson = 'application/json'
}
/**
    * @export
    * @enum {string}
    */
export enum GridForecastGeoJSONSerializerTypeEnum {
    FeatureCollection = 'FeatureCollection'
}

/**
 * 
 * @export
 * @interface GridForecastMetadataModel
 */
export interface GridForecastMetadataModel {
    /**
     * 
     * @type {string}
     * @memberof GridForecastMetadataModel
     */
    'title': string;
    /**
     * 
     * @type {Array<ParameterMetadataModel>}
     * @memberof GridForecastMetadataModel
     */
    'parameters': Array<ParameterMetadataModel>;
    /**
     * 
     * @type {Frequency}
     * @memberof GridForecastMetadataModel
     */
    'frequency': Frequency;
    /**
     * 
     * @type {string}
     * @memberof GridForecastMetadataModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GridForecastMetadataModel
     */
    'mode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GridForecastMetadataModel
     */
    'response_formats': Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<CodeListItem> | undefined; }}
     * @memberof GridForecastMetadataModel
     */
    'code_lists'?: { [key: string]: Array<CodeListItem> | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof GridForecastMetadataModel
     */
    'last_forecast_reftime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GridForecastMetadataModel
     */
    'max_forecast_offset'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GridForecastMetadataModel
     */
    'available_forecast_reftimes': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GridForecastMetadataModel
     */
    'forecast_length'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridForecastMetadataModel
     */
    'bbox': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridForecastMetadataModel
     */
    'bbox_outer': Array<number>;
    /**
     * 
     * @type {SpatialResolution}
     * @memberof GridForecastMetadataModel
     */
    'spatial_resolution': SpatialResolution;
    /**
     * 
     * @type {string}
     * @memberof GridForecastMetadataModel
     */
    'spatial_resolution_unit': string;
    /**
     * deprecated
     * @type {number}
     * @memberof GridForecastMetadataModel
     */
    'spatial_resolution_m': number;
    /**
     * 
     * @type {string}
     * @memberof GridForecastMetadataModel
     */
    'crs': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridForecastMetadataModel
     */
    'grid_bounds': Array<number>;
}
/**
 * 
 * @export
 * @interface GridGeoJSONSerializer
 */
export interface GridGeoJSONSerializer {
    /**
     * 
     * @type {string}
     * @memberof GridGeoJSONSerializer
     */
    'media_type'?: GridGeoJSONSerializerMediaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GridGeoJSONSerializer
     */
    'type'?: GridGeoJSONSerializerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GridGeoJSONSerializer
     */
    'version': string;
    /**
     * Format: *YYYY-MM-DDThh:mm:ss±hh:mm*
     * @type {Array<string>}
     * @memberof GridGeoJSONSerializer
     */
    'timestamps': Array<string>;
    /**
     * 
     * @type {Array<GeoJSONFeature>}
     * @memberof GridGeoJSONSerializer
     */
    'features': Array<GeoJSONFeature>;
    /**
     * 
     * @type {string}
     * @memberof GridGeoJSONSerializer
     */
    'filename'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridGeoJSONSerializer
     */
    'bbox': Array<number>;
}

/**
    * @export
    * @enum {string}
    */
export enum GridGeoJSONSerializerMediaTypeEnum {
    ApplicationJson = 'application/json'
}
/**
    * @export
    * @enum {string}
    */
export enum GridGeoJSONSerializerTypeEnum {
    FeatureCollection = 'FeatureCollection'
}

/**
 * 
 * @export
 * @interface GridHistoricalMetadataModel
 */
export interface GridHistoricalMetadataModel {
    /**
     * 
     * @type {string}
     * @memberof GridHistoricalMetadataModel
     */
    'title': string;
    /**
     * 
     * @type {Array<ParameterMetadataModel>}
     * @memberof GridHistoricalMetadataModel
     */
    'parameters': Array<ParameterMetadataModel>;
    /**
     * 
     * @type {Frequency}
     * @memberof GridHistoricalMetadataModel
     */
    'frequency': Frequency;
    /**
     * 
     * @type {string}
     * @memberof GridHistoricalMetadataModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GridHistoricalMetadataModel
     */
    'mode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GridHistoricalMetadataModel
     */
    'response_formats': Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<CodeListItem> | undefined; }}
     * @memberof GridHistoricalMetadataModel
     */
    'code_lists'?: { [key: string]: Array<CodeListItem> | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof GridHistoricalMetadataModel
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof GridHistoricalMetadataModel
     */
    'end_time': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridHistoricalMetadataModel
     */
    'bbox': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridHistoricalMetadataModel
     */
    'bbox_outer': Array<number>;
    /**
     * 
     * @type {SpatialResolution}
     * @memberof GridHistoricalMetadataModel
     */
    'spatial_resolution': SpatialResolution;
    /**
     * 
     * @type {string}
     * @memberof GridHistoricalMetadataModel
     */
    'spatial_resolution_unit': string;
    /**
     * deprecated
     * @type {number}
     * @memberof GridHistoricalMetadataModel
     */
    'spatial_resolution_m': number;
    /**
     * 
     * @type {string}
     * @memberof GridHistoricalMetadataModel
     */
    'crs': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GridHistoricalMetadataModel
     */
    'grid_bounds': Array<number>;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum IdType {
    Synop = 'Synop',
    Klima = 'Klima'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum MDType {
    Stations = 'stations',
    Parameters = 'parameters'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum OutputFormat {
    Geojson = 'geojson',
    Netcdf = 'netcdf',
    Csv = 'csv'
}


/**
 * 
 * @export
 * @interface ParameterMetadataModel
 */
export interface ParameterMetadataModel {
    /**
     * 
     * @type {string}
     * @memberof ParameterMetadataModel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ParameterMetadataModel
     */
    'long_name': string;
    /**
     * 
     * @type {string}
     * @memberof ParameterMetadataModel
     */
    'desc': string;
    /**
     * 
     * @type {string}
     * @memberof ParameterMetadataModel
     */
    'unit': string;
    /**
     * 
     * @type {string}
     * @memberof ParameterMetadataModel
     */
    'code_list_ref'?: string | null;
}
/**
 * 
 * @export
 * @interface SpatialResolution
 */
export interface SpatialResolution {
}
/**
 * 
 * @export
 * @interface SpatialResolutionAnyOfInner
 */
export interface SpatialResolutionAnyOfInner {
}
/**
 * 
 * @export
 * @interface StationCurrentMetadataModel
 */
export interface StationCurrentMetadataModel {
    /**
     * 
     * @type {string}
     * @memberof StationCurrentMetadataModel
     */
    'title': string;
    /**
     * 
     * @type {Array<ParameterMetadataModel>}
     * @memberof StationCurrentMetadataModel
     */
    'parameters': Array<ParameterMetadataModel>;
    /**
     * 
     * @type {Frequency}
     * @memberof StationCurrentMetadataModel
     */
    'frequency': Frequency;
    /**
     * 
     * @type {string}
     * @memberof StationCurrentMetadataModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof StationCurrentMetadataModel
     */
    'mode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StationCurrentMetadataModel
     */
    'response_formats': Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<CodeListItem> | undefined; }}
     * @memberof StationCurrentMetadataModel
     */
    'code_lists'?: { [key: string]: Array<CodeListItem> | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof StationCurrentMetadataModel
     */
    'time': string;
    /**
     * 
     * @type {Array<StationMetadata>}
     * @memberof StationCurrentMetadataModel
     */
    'stations': Array<StationMetadata>;
    /**
     * 
     * @type {IdType}
     * @memberof StationCurrentMetadataModel
     */
    'id_type': IdType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum StationFilterEndpointMode {
    Historical = 'historical',
    Current = 'current'
}


/**
 * 
 * @export
 * @interface StationFilterResponseDto
 */
export interface StationFilterResponseDto {
    /**
     * 
     * @type {number}
     * @memberof StationFilterResponseDto
     */
    'num_stations_total': number;
    /**
     * 
     * @type {number}
     * @memberof StationFilterResponseDto
     */
    'num_stations_matching': number;
    /**
     * 
     * @type {Array<StationMetadataDto>}
     * @memberof StationFilterResponseDto
     */
    'matching_stations': Array<StationMetadataDto>;
}
/**
 * 
 * @export
 * @interface StationGeoJSONFeature
 */
export interface StationGeoJSONFeature {
    /**
     * 
     * @type {string}
     * @memberof StationGeoJSONFeature
     */
    'type'?: StationGeoJSONFeatureTypeEnum;
    /**
     * 
     * @type {GeoJSONPoint}
     * @memberof StationGeoJSONFeature
     */
    'geometry': GeoJSONPoint;
    /**
     * 
     * @type {StationGeoJSONProperties}
     * @memberof StationGeoJSONFeature
     */
    'properties': StationGeoJSONProperties;
}

/**
    * @export
    * @enum {string}
    */
export enum StationGeoJSONFeatureTypeEnum {
    Feature = 'Feature'
}

/**
 * 
 * @export
 * @interface StationGeoJSONProperties
 */
export interface StationGeoJSONProperties {
    /**
     * 
     * @type {{ [key: string]: GeoJSONFeatureParameter | undefined; }}
     * @memberof StationGeoJSONProperties
     */
    'parameters': { [key: string]: GeoJSONFeatureParameter | undefined; };
    /**
     * 
     * @type {string}
     * @memberof StationGeoJSONProperties
     */
    'station': string;
}
/**
 * 
 * @export
 * @interface StationGeoJSONSerializer
 */
export interface StationGeoJSONSerializer {
    /**
     * 
     * @type {string}
     * @memberof StationGeoJSONSerializer
     */
    'media_type'?: StationGeoJSONSerializerMediaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StationGeoJSONSerializer
     */
    'type'?: StationGeoJSONSerializerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StationGeoJSONSerializer
     */
    'version': string;
    /**
     * Format: *YYYY-MM-DDThh:mm:ss±hh:mm*
     * @type {Array<string>}
     * @memberof StationGeoJSONSerializer
     */
    'timestamps': Array<string>;
    /**
     * 
     * @type {Array<StationGeoJSONFeature>}
     * @memberof StationGeoJSONSerializer
     */
    'features': Array<StationGeoJSONFeature>;
    /**
     * 
     * @type {string}
     * @memberof StationGeoJSONSerializer
     */
    'filename'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum StationGeoJSONSerializerMediaTypeEnum {
    ApplicationJson = 'application/json'
}
/**
    * @export
    * @enum {string}
    */
export enum StationGeoJSONSerializerTypeEnum {
    FeatureCollection = 'FeatureCollection'
}

/**
 * 
 * @export
 * @interface StationHistoricalMetadataModel
 */
export interface StationHistoricalMetadataModel {
    /**
     * 
     * @type {string}
     * @memberof StationHistoricalMetadataModel
     */
    'title': string;
    /**
     * 
     * @type {Array<ParameterMetadataModel>}
     * @memberof StationHistoricalMetadataModel
     */
    'parameters': Array<ParameterMetadataModel>;
    /**
     * 
     * @type {Frequency}
     * @memberof StationHistoricalMetadataModel
     */
    'frequency': Frequency;
    /**
     * 
     * @type {string}
     * @memberof StationHistoricalMetadataModel
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof StationHistoricalMetadataModel
     */
    'mode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StationHistoricalMetadataModel
     */
    'response_formats': Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<CodeListItem> | undefined; }}
     * @memberof StationHistoricalMetadataModel
     */
    'code_lists'?: { [key: string]: Array<CodeListItem> | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof StationHistoricalMetadataModel
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof StationHistoricalMetadataModel
     */
    'end_time': string;
    /**
     * 
     * @type {Array<StationMetadata>}
     * @memberof StationHistoricalMetadataModel
     */
    'stations': Array<StationMetadata>;
    /**
     * 
     * @type {IdType}
     * @memberof StationHistoricalMetadataModel
     */
    'id_type': IdType;
}


/**
 * 
 * @export
 * @interface StationMetadata
 */
export interface StationMetadata {
    /**
     * 
     * @type {StationMetadataType}
     * @memberof StationMetadata
     */
    'type': StationMetadataType;
    /**
     * 
     * @type {string}
     * @memberof StationMetadata
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StationMetadata
     */
    'group_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StationMetadata
     */
    'name': string;
    /**
     * 
     * @type {Bundesland}
     * @memberof StationMetadata
     */
    'state'?: Bundesland | null;
    /**
     * 
     * @type {number}
     * @memberof StationMetadata
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof StationMetadata
     */
    'lon': number;
    /**
     * 
     * @type {number}
     * @memberof StationMetadata
     */
    'altitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StationMetadata
     */
    'valid_from': string;
    /**
     * 
     * @type {string}
     * @memberof StationMetadata
     */
    'valid_to': string;
    /**
     * 
     * @type {boolean}
     * @memberof StationMetadata
     */
    'has_sunshine'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StationMetadata
     */
    'has_global_radiation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StationMetadata
     */
    'is_active'?: boolean | null;
}


/**
 * 
 * @export
 * @interface StationMetadataDto
 */
export interface StationMetadataDto {
    /**
     * 
     * @type {StationMetadataType}
     * @memberof StationMetadataDto
     */
    'type': StationMetadataType;
    /**
     * 
     * @type {string}
     * @memberof StationMetadataDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StationMetadataDto
     */
    'name': string;
    /**
     * 
     * @type {Bundesland}
     * @memberof StationMetadataDto
     */
    'state'?: Bundesland | null;
    /**
     * 
     * @type {number}
     * @memberof StationMetadataDto
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof StationMetadataDto
     */
    'lon': number;
    /**
     * 
     * @type {number}
     * @memberof StationMetadataDto
     */
    'altitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StationMetadataDto
     */
    'valid_from': string;
    /**
     * 
     * @type {string}
     * @memberof StationMetadataDto
     */
    'valid_to': string;
    /**
     * 
     * @type {boolean}
     * @memberof StationMetadataDto
     */
    'has_sunshine'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StationMetadataDto
     */
    'has_global_radiation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof StationMetadataDto
     */
    'is_active'?: boolean | null;
    /**
     * List of sub-stations of this station. Only populated if type == COMBINED.
     * @type {Array<StationMetadataDto>}
     * @memberof StationMetadataDto
     */
    'sub_stations'?: Array<StationMetadataDto>;
    /**
     * 
     * @type {boolean}
     * @memberof StationMetadataDto
     */
    'matches'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum StationMetadataType {
    Combined = 'COMBINED',
    SubStation = 'SUB_STATION',
    Individual = 'INDIVIDUAL'
}


/**
 * 
 * @export
 * @interface TimeseriesForecastGeoJSONSerializer
 */
export interface TimeseriesForecastGeoJSONSerializer {
    /**
     * 
     * @type {string}
     * @memberof TimeseriesForecastGeoJSONSerializer
     */
    'reference_time': string;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesForecastGeoJSONSerializer
     */
    'media_type'?: TimeseriesForecastGeoJSONSerializerMediaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesForecastGeoJSONSerializer
     */
    'type'?: TimeseriesForecastGeoJSONSerializerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesForecastGeoJSONSerializer
     */
    'version': string;
    /**
     * Format: *YYYY-MM-DDThh:mm:ss±hh:mm*
     * @type {Array<string>}
     * @memberof TimeseriesForecastGeoJSONSerializer
     */
    'timestamps': Array<string>;
    /**
     * 
     * @type {Array<GeoJSONFeature>}
     * @memberof TimeseriesForecastGeoJSONSerializer
     */
    'features': Array<GeoJSONFeature>;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesForecastGeoJSONSerializer
     */
    'filename'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum TimeseriesForecastGeoJSONSerializerMediaTypeEnum {
    ApplicationJson = 'application/json'
}
/**
    * @export
    * @enum {string}
    */
export enum TimeseriesForecastGeoJSONSerializerTypeEnum {
    FeatureCollection = 'FeatureCollection'
}

/**
 * 
 * @export
 * @interface TimeseriesGeoJSONSerializer
 */
export interface TimeseriesGeoJSONSerializer {
    /**
     * 
     * @type {string}
     * @memberof TimeseriesGeoJSONSerializer
     */
    'media_type'?: TimeseriesGeoJSONSerializerMediaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesGeoJSONSerializer
     */
    'type'?: TimeseriesGeoJSONSerializerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesGeoJSONSerializer
     */
    'version': string;
    /**
     * Format: *YYYY-MM-DDThh:mm:ss±hh:mm*
     * @type {Array<string>}
     * @memberof TimeseriesGeoJSONSerializer
     */
    'timestamps': Array<string>;
    /**
     * 
     * @type {Array<GeoJSONFeature>}
     * @memberof TimeseriesGeoJSONSerializer
     */
    'features': Array<GeoJSONFeature>;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesGeoJSONSerializer
     */
    'filename'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum TimeseriesGeoJSONSerializerMediaTypeEnum {
    ApplicationJson = 'application/json'
}
/**
    * @export
    * @enum {string}
    */
export enum TimeseriesGeoJSONSerializerTypeEnum {
    FeatureCollection = 'FeatureCollection'
}

/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'input'?: any;
    /**
     * 
     * @type {object}
     * @memberof ValidationError
     */
    'ctx'?: object;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * AllDatasetsApi - axios parameter creator
 * @export
 */
export const AllDatasetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary View And Filter All Available Datasets
         * @param {EndpointType | null} [type] 
         * @param {EndpointMode | null} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewAndFilterAllAvailableDatasetsDatasetsGet: async (type?: EndpointType | null, mode?: EndpointMode | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllDatasetsApi - functional programming interface
 * @export
 */
export const AllDatasetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllDatasetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary View And Filter All Available Datasets
         * @param {EndpointType | null} [type] 
         * @param {EndpointMode | null} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewAndFilterAllAvailableDatasetsDatasetsGet(type?: EndpointType | null, mode?: EndpointMode | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Dataset | undefined; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewAndFilterAllAvailableDatasetsDatasetsGet(type, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllDatasetsApi.viewAndFilterAllAvailableDatasetsDatasetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllDatasetsApi - factory interface
 * @export
 */
export const AllDatasetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllDatasetsApiFp(configuration)
    return {
        /**
         * 
         * @summary View And Filter All Available Datasets
         * @param {EndpointType | null} [type] 
         * @param {EndpointMode | null} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewAndFilterAllAvailableDatasetsDatasetsGet(type?: EndpointType | null, mode?: EndpointMode | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Dataset | undefined; }> {
            return localVarFp.viewAndFilterAllAvailableDatasetsDatasetsGet(type, mode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllDatasetsApi - object-oriented interface
 * @export
 * @class AllDatasetsApi
 * @extends {BaseAPI}
 */
export class AllDatasetsApi extends BaseAPI {
    /**
     * 
     * @summary View And Filter All Available Datasets
     * @param {EndpointType | null} [type] 
     * @param {EndpointMode | null} [mode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllDatasetsApi
     */
    public viewAndFilterAllAvailableDatasetsDatasetsGet(type?: EndpointType | null, mode?: EndpointMode | null, options?: RawAxiosRequestConfig) {
        return AllDatasetsApiFp(this.configuration).viewAndFilterAllAvailableDatasetsDatasetsGet(type, mode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CurrentApi - axios parameter creator
 * @export
 */
export const CurrentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Current Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationDataStationCurrentResourceIdGet: async (resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('currentStationDataStationCurrentResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('currentStationDataStationCurrentResourceIdGet', 'parameters', parameters)
            // verify required parameter 'stationIds' is not null or undefined
            assertParamExists('currentStationDataStationCurrentResourceIdGet', 'stationIds', stationIds)
            const localVarPath = `/station/current/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (stationIds) {
                localVarQueryParameter['station_ids'] = stationIds;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationMetadataStationCurrentResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('currentStationMetadataStationCurrentResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/station/current/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrentApi - functional programming interface
 * @export
 */
export const CurrentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Current Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentStationDataStationCurrentResourceIdGet(resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentStationDataStationCurrentResourceIdGet(resourceId, parameters, stationIds, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrentApi.currentStationDataStationCurrentResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationCurrentMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CurrentApi.currentStationMetadataStationCurrentResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CurrentApi - factory interface
 * @export
 */
export const CurrentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrentApiFp(configuration)
    return {
        /**
         * 
         * @summary Current Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationDataStationCurrentResourceIdGet(resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<StationGeoJSONSerializer> {
            return localVarFp.currentStationDataStationCurrentResourceIdGet(resourceId, parameters, stationIds, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<StationCurrentMetadataModel> {
            return localVarFp.currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrentApi - object-oriented interface
 * @export
 * @class CurrentApi
 * @extends {BaseAPI}
 */
export class CurrentApi extends BaseAPI {
    /**
     * 
     * @summary Current Station Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {Array<string>} stationIds At least one station id has to be specified.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentApi
     */
    public currentStationDataStationCurrentResourceIdGet(resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return CurrentApiFp(this.configuration).currentStationDataStationCurrentResourceIdGet(resourceId, parameters, stationIds, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Current Station Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentApi
     */
    public currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return CurrentApiFp(this.configuration).currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ForecastApi - axios parameter creator
 * @export
 */
export const ForecastApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Grid Forecast Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastDataGridForecastResourceIdGet: async (resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('gridForecastDataGridForecastResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('gridForecastDataGridForecastResourceIdGet', 'parameters', parameters)
            // verify required parameter 'bbox' is not null or undefined
            assertParamExists('gridForecastDataGridForecastResourceIdGet', 'bbox', bbox)
            const localVarPath = `/grid/forecast/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (forecastOffset !== undefined) {
                localVarQueryParameter['forecast_offset'] = forecastOffset;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastMetadataGridForecastResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('gridForecastMetadataGridForecastResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/grid/forecast/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/timeseries/forecast/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Timeseries Forecast
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastTimeseriesForecastResourceIdGet: async (resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('timeseriesForecastTimeseriesForecastResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('timeseriesForecastTimeseriesForecastResourceIdGet', 'parameters', parameters)
            // verify required parameter 'latLon' is not null or undefined
            assertParamExists('timeseriesForecastTimeseriesForecastResourceIdGet', 'latLon', latLon)
            const localVarPath = `/timeseries/forecast/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (latLon) {
                localVarQueryParameter['lat_lon'] = latLon;
            }

            if (forecastOffset !== undefined) {
                localVarQueryParameter['forecast_offset'] = forecastOffset;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForecastApi - functional programming interface
 * @export
 */
export const ForecastApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForecastApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Grid Forecast Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gridForecastDataGridForecastResourceIdGet(resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gridForecastDataGridForecastResourceIdGet(resourceId, parameters, bbox, forecastOffset, start, end, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastApi.gridForecastDataGridForecastResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastApi.gridForecastMetadataGridForecastResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastApi.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Timeseries Forecast
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeseriesForecastTimeseriesForecastResourceIdGet(resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeseriesForecastGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timeseriesForecastTimeseriesForecastResourceIdGet(resourceId, parameters, latLon, forecastOffset, start, end, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForecastApi.timeseriesForecastTimeseriesForecastResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ForecastApi - factory interface
 * @export
 */
export const ForecastApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForecastApiFp(configuration)
    return {
        /**
         * 
         * @summary Grid Forecast Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastDataGridForecastResourceIdGet(resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastGeoJSONSerializer> {
            return localVarFp.gridForecastDataGridForecastResourceIdGet(resourceId, parameters, bbox, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastMetadataModel> {
            return localVarFp.gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastMetadataModel> {
            return localVarFp.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Timeseries Forecast
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastTimeseriesForecastResourceIdGet(resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TimeseriesForecastGeoJSONSerializer> {
            return localVarFp.timeseriesForecastTimeseriesForecastResourceIdGet(resourceId, parameters, latLon, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForecastApi - object-oriented interface
 * @export
 * @class ForecastApi
 * @extends {BaseAPI}
 */
export class ForecastApi extends BaseAPI {
    /**
     * 
     * @summary Grid Forecast Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} bbox Supply in format *south,west,north,east*
     * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
     * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public gridForecastDataGridForecastResourceIdGet(resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return ForecastApiFp(this.configuration).gridForecastDataGridForecastResourceIdGet(resourceId, parameters, bbox, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grid Forecast Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return ForecastApiFp(this.configuration).gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Timeseries Forecast Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return ForecastApiFp(this.configuration).timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Timeseries Forecast
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
     * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
     * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForecastApi
     */
    public timeseriesForecastTimeseriesForecastResourceIdGet(resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return ForecastApiFp(this.configuration).timeseriesForecastTimeseriesForecastResourceIdGet(resourceId, parameters, latLon, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GridApi - axios parameter creator
 * @export
 */
export const GridApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Grid Forecast Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastDataGridForecastResourceIdGet: async (resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('gridForecastDataGridForecastResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('gridForecastDataGridForecastResourceIdGet', 'parameters', parameters)
            // verify required parameter 'bbox' is not null or undefined
            assertParamExists('gridForecastDataGridForecastResourceIdGet', 'bbox', bbox)
            const localVarPath = `/grid/forecast/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (forecastOffset !== undefined) {
                localVarQueryParameter['forecast_offset'] = forecastOffset;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastMetadataGridForecastResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('gridForecastMetadataGridForecastResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/grid/forecast/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Grid Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridDataGridHistoricalResourceIdGet: async (resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'parameters', parameters)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'end', end)
            // verify required parameter 'bbox' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'bbox', bbox)
            const localVarPath = `/grid/historical/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridMetadataGridHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridMetadataGridHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/grid/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet: async (resourceId: string, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet', 'resourceId', resourceId)
            const localVarPath = `/grid/historical/{resource_id}/metadata/parameters`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridApi - functional programming interface
 * @export
 */
export const GridApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Grid Forecast Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gridForecastDataGridForecastResourceIdGet(resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gridForecastDataGridForecastResourceIdGet(resourceId, parameters, bbox, forecastOffset, start, end, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.gridForecastDataGridForecastResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.gridForecastMetadataGridForecastResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Grid Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridDataGridHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridDataGridHistoricalResourceIdGet(resourceId, parameters, start, end, bbox, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.historicalGridDataGridHistoricalResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.historicalGridMetadataGridHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GridApi.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GridApi - factory interface
 * @export
 */
export const GridApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridApiFp(configuration)
    return {
        /**
         * 
         * @summary Grid Forecast Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastDataGridForecastResourceIdGet(resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastGeoJSONSerializer> {
            return localVarFp.gridForecastDataGridForecastResourceIdGet(resourceId, parameters, bbox, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastMetadataModel> {
            return localVarFp.gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Grid Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridDataGridHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<GridGeoJSONSerializer> {
            return localVarFp.historicalGridDataGridHistoricalResourceIdGet(resourceId, parameters, start, end, bbox, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridHistoricalMetadataModel> {
            return localVarFp.historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridApi - object-oriented interface
 * @export
 * @class GridApi
 * @extends {BaseAPI}
 */
export class GridApi extends BaseAPI {
    /**
     * 
     * @summary Grid Forecast Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} bbox Supply in format *south,west,north,east*
     * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
     * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridApi
     */
    public gridForecastDataGridForecastResourceIdGet(resourceId: string, parameters: Array<string>, bbox: string, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).gridForecastDataGridForecastResourceIdGet(resourceId, parameters, bbox, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grid Forecast Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridApi
     */
    public gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Grid Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} bbox Supply in format *south,west,north,east*
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridApi
     */
    public historicalGridDataGridHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).historicalGridDataGridHistoricalResourceIdGet(resourceId, parameters, start, end, bbox, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Grid Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridApi
     */
    public historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Grid Parameter Metadata Csv
     * @param {string} resourceId ID of dataset
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridApi
     */
    public historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig) {
        return GridApiFp(this.configuration).historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HistoricalApi - axios parameter creator
 * @export
 */
export const HistoricalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Historical Grid Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridDataGridHistoricalResourceIdGet: async (resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'parameters', parameters)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'end', end)
            // verify required parameter 'bbox' is not null or undefined
            assertParamExists('historicalGridDataGridHistoricalResourceIdGet', 'bbox', bbox)
            const localVarPath = `/grid/historical/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (bbox !== undefined) {
                localVarQueryParameter['bbox'] = bbox;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridMetadataGridHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridMetadataGridHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/grid/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet: async (resourceId: string, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet', 'resourceId', resourceId)
            const localVarPath = `/grid/historical/{resource_id}/metadata/parameters`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationDataStationHistoricalResourceIdGet: async (resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'parameters', parameters)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'end', end)
            // verify required parameter 'stationIds' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'stationIds', stationIds)
            const localVarPath = `/station/historical/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (stationIds) {
                localVarQueryParameter['station_ids'] = stationIds;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet: async (mdtype: MDType, resourceId: string, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mdtype' is not null or undefined
            assertParamExists('historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet', 'mdtype', mdtype)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet', 'resourceId', resourceId)
            const localVarPath = `/station/historical/{resource_id}/metadata/{mdtype}`
                .replace(`{${"mdtype"}}`, encodeURIComponent(String(mdtype)))
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataStationHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationMetadataStationHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/station/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/timeseries/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Timeseries
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesTimeseriesHistoricalResourceIdGet: async (resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'parameters', parameters)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'end', end)
            // verify required parameter 'latLon' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'latLon', latLon)
            const localVarPath = `/timeseries/historical/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (latLon) {
                localVarQueryParameter['lat_lon'] = latLon;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoricalApi - functional programming interface
 * @export
 */
export const HistoricalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HistoricalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Historical Grid Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridDataGridHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridDataGridHistoricalResourceIdGet(resourceId, parameters, start, end, bbox, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalGridDataGridHistoricalResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalGridMetadataGridHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationDataStationHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationDataStationHistoricalResourceIdGet(resourceId, parameters, start, end, stationIds, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalStationDataStationHistoricalResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalStationMetadataStationHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Timeseries
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeseriesGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId, parameters, start, end, latLon, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoricalApi.historicalTimeseriesTimeseriesHistoricalResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HistoricalApi - factory interface
 * @export
 */
export const HistoricalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HistoricalApiFp(configuration)
    return {
        /**
         * 
         * @summary Historical Grid Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} bbox Supply in format *south,west,north,east*
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridDataGridHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<GridGeoJSONSerializer> {
            return localVarFp.historicalGridDataGridHistoricalResourceIdGet(resourceId, parameters, start, end, bbox, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridHistoricalMetadataModel> {
            return localVarFp.historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationDataStationHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<StationGeoJSONSerializer> {
            return localVarFp.historicalStationDataStationHistoricalResourceIdGet(resourceId, parameters, start, end, stationIds, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<StationHistoricalMetadataModel> {
            return localVarFp.historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridHistoricalMetadataModel> {
            return localVarFp.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Timeseries
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TimeseriesGeoJSONSerializer> {
            return localVarFp.historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId, parameters, start, end, latLon, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoricalApi - object-oriented interface
 * @export
 * @class HistoricalApi
 * @extends {BaseAPI}
 */
export class HistoricalApi extends BaseAPI {
    /**
     * 
     * @summary Historical Grid Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} bbox Supply in format *south,west,north,east*
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalGridDataGridHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, bbox: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalGridDataGridHistoricalResourceIdGet(resourceId, parameters, start, end, bbox, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Grid Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Grid Parameter Metadata Csv
     * @param {string} resourceId ID of dataset
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {Array<string>} stationIds At least one station id has to be specified.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalStationDataStationHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalStationDataStationHistoricalResourceIdGet(resourceId, parameters, start, end, stationIds, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Metadata Csv
     * @param {MDType} mdtype 
     * @param {string} resourceId ID of dataset
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Timeseries Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Timeseries
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoricalApi
     */
    public historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return HistoricalApiFp(this.configuration).historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId, parameters, start, end, latLon, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetadataApi - axios parameter creator
 * @export
 */
export const MetadataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationMetadataStationCurrentResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('currentStationMetadataStationCurrentResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/station/current/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastMetadataGridForecastResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('gridForecastMetadataGridForecastResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/grid/forecast/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridMetadataGridHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridMetadataGridHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/grid/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet: async (resourceId: string, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet', 'resourceId', resourceId)
            const localVarPath = `/grid/historical/{resource_id}/metadata/parameters`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet: async (mdtype: MDType, resourceId: string, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mdtype' is not null or undefined
            assertParamExists('historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet', 'mdtype', mdtype)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet', 'resourceId', resourceId)
            const localVarPath = `/station/historical/{resource_id}/metadata/{mdtype}`
                .replace(`{${"mdtype"}}`, encodeURIComponent(String(mdtype)))
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataStationHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationMetadataStationHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/station/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/timeseries/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/timeseries/forecast/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetadataApi - functional programming interface
 * @export
 */
export const MetadataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetadataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationCurrentMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.currentStationMetadataStationCurrentResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.gridForecastMetadataGridForecastResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.historicalGridMetadataGridHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.historicalStationMetadataStationHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadataApi.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetadataApi - factory interface
 * @export
 */
export const MetadataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetadataApiFp(configuration)
    return {
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<StationCurrentMetadataModel> {
            return localVarFp.currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grid Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastMetadataModel> {
            return localVarFp.gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Grid Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridHistoricalMetadataModel> {
            return localVarFp.historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Grid Parameter Metadata Csv
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<StationHistoricalMetadataModel> {
            return localVarFp.historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridHistoricalMetadataModel> {
            return localVarFp.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastMetadataModel> {
            return localVarFp.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetadataApi - object-oriented interface
 * @export
 * @class MetadataApi
 * @extends {BaseAPI}
 */
export class MetadataApi extends BaseAPI {
    /**
     * 
     * @summary Current Station Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grid Forecast Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).gridForecastMetadataGridForecastResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Grid Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).historicalGridMetadataGridHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Grid Parameter Metadata Csv
     * @param {string} resourceId ID of dataset
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).historicalGridParameterMetadataCSVGridHistoricalResourceIdMetadataParametersGet(resourceId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Metadata Csv
     * @param {MDType} mdtype 
     * @param {string} resourceId ID of dataset
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Timeseries Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Timeseries Forecast Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadataApi
     */
    public timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return MetadataApiFp(this.configuration).timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StationApi - axios parameter creator
 * @export
 */
export const StationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Current Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationDataStationCurrentResourceIdGet: async (resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('currentStationDataStationCurrentResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('currentStationDataStationCurrentResourceIdGet', 'parameters', parameters)
            // verify required parameter 'stationIds' is not null or undefined
            assertParamExists('currentStationDataStationCurrentResourceIdGet', 'stationIds', stationIds)
            const localVarPath = `/station/current/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (stationIds) {
                localVarQueryParameter['station_ids'] = stationIds;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationMetadataStationCurrentResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('currentStationMetadataStationCurrentResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/station/current/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Filter Stations
         * @param {string} resourceId ID of dataset
         * @param {StationFilterEndpointMode} mode 
         * @param {Array<string>} [id] Restricts output to stations that have one of the given ids.
         * @param {Array<string>} [name] Restricts output to stations whose name contains one of the given strings.
         * @param {Array<Bundesland>} [state] Restricts output to stations who are located in one of the given states
         * @param {string} [startDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
         * @param {string} [endDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
         * @param {number} [minAltitude] Physical unit is *m*
         * @param {number | null} [maxAltitude] Physical unit is *m*
         * @param {boolean} [hasSunshine] 
         * @param {boolean} [hasGlobalRadiation] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterStationsStationModeResourceIdFilterGet: async (resourceId: string, mode: StationFilterEndpointMode, id?: Array<string>, name?: Array<string>, state?: Array<Bundesland>, startDate?: string, endDate?: string, minAltitude?: number, maxAltitude?: number | null, hasSunshine?: boolean, hasGlobalRadiation?: boolean, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('filterStationsStationModeResourceIdFilterGet', 'resourceId', resourceId)
            // verify required parameter 'mode' is not null or undefined
            assertParamExists('filterStationsStationModeResourceIdFilterGet', 'mode', mode)
            const localVarPath = `/station/{mode}/{resource_id}/filter`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)))
                .replace(`{${"mode"}}`, encodeURIComponent(String(mode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (id) {
                localVarQueryParameter['id'] = id;
            }

            if (name) {
                localVarQueryParameter['name'] = name;
            }

            if (state) {
                localVarQueryParameter['state'] = state;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (minAltitude !== undefined) {
                localVarQueryParameter['min_altitude'] = minAltitude;
            }

            if (maxAltitude !== undefined) {
                localVarQueryParameter['max_altitude'] = maxAltitude;
            }

            if (hasSunshine !== undefined) {
                localVarQueryParameter['has_sunshine'] = hasSunshine;
            }

            if (hasGlobalRadiation !== undefined) {
                localVarQueryParameter['has_global_radiation'] = hasGlobalRadiation;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationDataStationHistoricalResourceIdGet: async (resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'parameters', parameters)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'end', end)
            // verify required parameter 'stationIds' is not null or undefined
            assertParamExists('historicalStationDataStationHistoricalResourceIdGet', 'stationIds', stationIds)
            const localVarPath = `/station/historical/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (stationIds) {
                localVarQueryParameter['station_ids'] = stationIds;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet: async (mdtype: MDType, resourceId: string, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mdtype' is not null or undefined
            assertParamExists('historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet', 'mdtype', mdtype)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet', 'resourceId', resourceId)
            const localVarPath = `/station/historical/{resource_id}/metadata/{mdtype}`
                .replace(`{${"mdtype"}}`, encodeURIComponent(String(mdtype)))
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataStationHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalStationMetadataStationHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/station/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationApi - functional programming interface
 * @export
 */
export const StationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Current Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentStationDataStationCurrentResourceIdGet(resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentStationDataStationCurrentResourceIdGet(resourceId, parameters, stationIds, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.currentStationDataStationCurrentResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationCurrentMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.currentStationMetadataStationCurrentResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Filter Stations
         * @param {string} resourceId ID of dataset
         * @param {StationFilterEndpointMode} mode 
         * @param {Array<string>} [id] Restricts output to stations that have one of the given ids.
         * @param {Array<string>} [name] Restricts output to stations whose name contains one of the given strings.
         * @param {Array<Bundesland>} [state] Restricts output to stations who are located in one of the given states
         * @param {string} [startDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
         * @param {string} [endDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
         * @param {number} [minAltitude] Physical unit is *m*
         * @param {number | null} [maxAltitude] Physical unit is *m*
         * @param {boolean} [hasSunshine] 
         * @param {boolean} [hasGlobalRadiation] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterStationsStationModeResourceIdFilterGet(resourceId: string, mode: StationFilterEndpointMode, id?: Array<string>, name?: Array<string>, state?: Array<Bundesland>, startDate?: string, endDate?: string, minAltitude?: number, maxAltitude?: number | null, hasSunshine?: boolean, hasGlobalRadiation?: boolean, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationFilterResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterStationsStationModeResourceIdFilterGet(resourceId, mode, id, name, state, startDate, endDate, minAltitude, maxAltitude, hasSunshine, hasGlobalRadiation, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.filterStationsStationModeResourceIdFilterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationDataStationHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationDataStationHistoricalResourceIdGet(resourceId, parameters, start, end, stationIds, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.historicalStationDataStationHistoricalResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StationApi.historicalStationMetadataStationHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StationApi - factory interface
 * @export
 */
export const StationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StationApiFp(configuration)
    return {
        /**
         * 
         * @summary Current Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationDataStationCurrentResourceIdGet(resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<StationGeoJSONSerializer> {
            return localVarFp.currentStationDataStationCurrentResourceIdGet(resourceId, parameters, stationIds, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Current Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<StationCurrentMetadataModel> {
            return localVarFp.currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Filter Stations
         * @param {string} resourceId ID of dataset
         * @param {StationFilterEndpointMode} mode 
         * @param {Array<string>} [id] Restricts output to stations that have one of the given ids.
         * @param {Array<string>} [name] Restricts output to stations whose name contains one of the given strings.
         * @param {Array<Bundesland>} [state] Restricts output to stations who are located in one of the given states
         * @param {string} [startDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
         * @param {string} [endDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
         * @param {number} [minAltitude] Physical unit is *m*
         * @param {number | null} [maxAltitude] Physical unit is *m*
         * @param {boolean} [hasSunshine] 
         * @param {boolean} [hasGlobalRadiation] 
         * @param {boolean} [isActive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterStationsStationModeResourceIdFilterGet(resourceId: string, mode: StationFilterEndpointMode, id?: Array<string>, name?: Array<string>, state?: Array<Bundesland>, startDate?: string, endDate?: string, minAltitude?: number, maxAltitude?: number | null, hasSunshine?: boolean, hasGlobalRadiation?: boolean, isActive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<StationFilterResponseDto> {
            return localVarFp.filterStationsStationModeResourceIdFilterGet(resourceId, mode, id, name, state, startDate, endDate, minAltitude, maxAltitude, hasSunshine, hasGlobalRadiation, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Data
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} stationIds At least one station id has to be specified.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationDataStationHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<StationGeoJSONSerializer> {
            return localVarFp.historicalStationDataStationHistoricalResourceIdGet(resourceId, parameters, start, end, stationIds, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Metadata Csv
         * @param {MDType} mdtype 
         * @param {string} resourceId ID of dataset
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Station Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<StationHistoricalMetadataModel> {
            return localVarFp.historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationApi - object-oriented interface
 * @export
 * @class StationApi
 * @extends {BaseAPI}
 */
export class StationApi extends BaseAPI {
    /**
     * 
     * @summary Current Station Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {Array<string>} stationIds At least one station id has to be specified.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public currentStationDataStationCurrentResourceIdGet(resourceId: string, parameters: Array<string>, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).currentStationDataStationCurrentResourceIdGet(resourceId, parameters, stationIds, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Current Station Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).currentStationMetadataStationCurrentResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Filter Stations
     * @param {string} resourceId ID of dataset
     * @param {StationFilterEndpointMode} mode 
     * @param {Array<string>} [id] Restricts output to stations that have one of the given ids.
     * @param {Array<string>} [name] Restricts output to stations whose name contains one of the given strings.
     * @param {Array<Bundesland>} [state] Restricts output to stations who are located in one of the given states
     * @param {string} [startDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
     * @param {string} [endDate] Supply in format: *YYYY-MM-DD* or *YYYY-MM-DDTHH:mm*
     * @param {number} [minAltitude] Physical unit is *m*
     * @param {number | null} [maxAltitude] Physical unit is *m*
     * @param {boolean} [hasSunshine] 
     * @param {boolean} [hasGlobalRadiation] 
     * @param {boolean} [isActive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public filterStationsStationModeResourceIdFilterGet(resourceId: string, mode: StationFilterEndpointMode, id?: Array<string>, name?: Array<string>, state?: Array<Bundesland>, startDate?: string, endDate?: string, minAltitude?: number, maxAltitude?: number | null, hasSunshine?: boolean, hasGlobalRadiation?: boolean, isActive?: boolean, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).filterStationsStationModeResourceIdFilterGet(resourceId, mode, id, name, state, startDate, endDate, minAltitude, maxAltitude, hasSunshine, hasGlobalRadiation, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Data
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {Array<string>} stationIds At least one station id has to be specified.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public historicalStationDataStationHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, stationIds: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).historicalStationDataStationHistoricalResourceIdGet(resourceId, parameters, start, end, stationIds, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Metadata Csv
     * @param {MDType} mdtype 
     * @param {string} resourceId ID of dataset
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype: MDType, resourceId: string, filename?: string | null, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).historicalStationMetadataCSVStationHistoricalResourceIdMetadataMdtypeGet(mdtype, resourceId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Station Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationApi
     */
    public historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return StationApiFp(this.configuration).historicalStationMetadataStationHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TimeseriesApi - axios parameter creator
 * @export
 */
export const TimeseriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/timeseries/historical/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Historical Timeseries
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesTimeseriesHistoricalResourceIdGet: async (resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'parameters', parameters)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'end', end)
            // verify required parameter 'latLon' is not null or undefined
            assertParamExists('historicalTimeseriesTimeseriesHistoricalResourceIdGet', 'latLon', latLon)
            const localVarPath = `/timeseries/historical/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (latLon) {
                localVarQueryParameter['lat_lon'] = latLon;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet: async (resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet', 'resourceId', resourceId)
            const localVarPath = `/timeseries/forecast/{resource_id}/metadata`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Timeseries Forecast
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastTimeseriesForecastResourceIdGet: async (resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('timeseriesForecastTimeseriesForecastResourceIdGet', 'resourceId', resourceId)
            // verify required parameter 'parameters' is not null or undefined
            assertParamExists('timeseriesForecastTimeseriesForecastResourceIdGet', 'parameters', parameters)
            // verify required parameter 'latLon' is not null or undefined
            assertParamExists('timeseriesForecastTimeseriesForecastResourceIdGet', 'latLon', latLon)
            const localVarPath = `/timeseries/forecast/{resource_id}`
                .replace(`{${"resource_id"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (parameters) {
                localVarQueryParameter['parameters'] = parameters;
            }

            if (latLon) {
                localVarQueryParameter['lat_lon'] = latLon;
            }

            if (forecastOffset !== undefined) {
                localVarQueryParameter['forecast_offset'] = forecastOffset;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (outputFormat !== undefined) {
                localVarQueryParameter['output_format'] = outputFormat;
            }

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeseriesApi - functional programming interface
 * @export
 */
export const TimeseriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeseriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridHistoricalMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeseriesApi.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Historical Timeseries
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeseriesGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId, parameters, start, end, latLon, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeseriesApi.historicalTimeseriesTimeseriesHistoricalResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridForecastMetadataModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeseriesApi.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Timeseries Forecast
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timeseriesForecastTimeseriesForecastResourceIdGet(resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeseriesForecastGeoJSONSerializer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timeseriesForecastTimeseriesForecastResourceIdGet(resourceId, parameters, latLon, forecastOffset, start, end, outputFormat, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimeseriesApi.timeseriesForecastTimeseriesForecastResourceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TimeseriesApi - factory interface
 * @export
 */
export const TimeseriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeseriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Historical Timeseries Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridHistoricalMetadataModel> {
            return localVarFp.historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Historical Timeseries
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TimeseriesGeoJSONSerializer> {
            return localVarFp.historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId, parameters, start, end, latLon, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Timeseries Forecast Metadata
         * @param {string} resourceId ID of dataset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<GridForecastMetadataModel> {
            return localVarFp.timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Timeseries Forecast
         * @param {string} resourceId ID of dataset
         * @param {Array<string>} parameters At least one parameter has to be specified.
         * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
         * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
         * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
         * @param {OutputFormat} [outputFormat] 
         * @param {string | null} [filename] Filename without file extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timeseriesForecastTimeseriesForecastResourceIdGet(resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TimeseriesForecastGeoJSONSerializer> {
            return localVarFp.timeseriesForecastTimeseriesForecastResourceIdGet(resourceId, parameters, latLon, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeseriesApi - object-oriented interface
 * @export
 * @class TimeseriesApi
 * @extends {BaseAPI}
 */
export class TimeseriesApi extends BaseAPI {
    /**
     * 
     * @summary Historical Timeseries Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeseriesApi
     */
    public historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return TimeseriesApiFp(this.configuration).historicalTimeseriesMetadataTimeseriesHistoricalResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Historical Timeseries
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {string} start Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} end Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeseriesApi
     */
    public historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId: string, parameters: Array<string>, start: string, end: string, latLon: Array<string>, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return TimeseriesApiFp(this.configuration).historicalTimeseriesTimeseriesHistoricalResourceIdGet(resourceId, parameters, start, end, latLon, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Timeseries Forecast Metadata
     * @param {string} resourceId ID of dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeseriesApi
     */
    public timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId: string, options?: RawAxiosRequestConfig) {
        return TimeseriesApiFp(this.configuration).timeseriesForecastMetadataTimeseriesForecastResourceIdMetadataGet(resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Timeseries Forecast
     * @param {string} resourceId ID of dataset
     * @param {Array<string>} parameters At least one parameter has to be specified.
     * @param {Array<string>} latLon Strings of \&#39;LAT,LON\&#39;.
     * @param {number} [forecastOffset] This parameter allows to access historical forecasts. If this parameter is not set the most recently created forecast is returned. If an integer value is given an older forecast is returned, where value is the \&#39;age\&#39; of the forecast. 0 is the most recent forecast, 1 is the second to last forecast, and so on.
     * @param {string} [start] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {string} [end] Supply in format: *YYYY-MM-DDThh:mm*. Time is optional.
     * @param {OutputFormat} [outputFormat] 
     * @param {string | null} [filename] Filename without file extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeseriesApi
     */
    public timeseriesForecastTimeseriesForecastResourceIdGet(resourceId: string, parameters: Array<string>, latLon: Array<string>, forecastOffset?: number, start?: string, end?: string, outputFormat?: OutputFormat, filename?: string | null, options?: RawAxiosRequestConfig) {
        return TimeseriesApiFp(this.configuration).timeseriesForecastTimeseriesForecastResourceIdGet(resourceId, parameters, latLon, forecastOffset, start, end, outputFormat, filename, options).then((request) => request(this.axios, this.basePath));
    }
}



